export default [
    {
        path: '/fs',
        name: 'fotosmile-entry',
        component: () => import(/* webpackChunkName: "fotosmile" */ '../domain/fotosmile/FotosmileEntry.vue'),
    },
    {
        path: '/fs/unlocked',
        name: 'fotosmile-unlocked',
        component: () => import(/* webpackChunkName: "fotosmile" */ '../domain/fotosmile/FotosmileUnlocked.vue'),
        meta: {
            requiresAuth: true,
        },
    },
]
